angular.module('qkr').controller('couponLocationController', ($scope, $uibModalInstance, merchantService,
                                                              gettextCatalog, locations, deptBasedCoupon) => {
    $scope.allSelected = true;
    $scope.deptBasedCoupon = deptBasedCoupon;
    $scope.supplyCoupon = merchantService.behaviour(merchantService.merchantInfo, 'couponPage.supplyCoupon');
    $scope.locations = locations;

    $scope.init = function() {
        // Set allSelected
        $scope.allSelected = $scope.isAllSelected();
    };

    $scope.selectAll = function() {
        if ($scope.allSelected) {
            $scope.locations = $scope.locations.map(location => Object.assign(location, { selected : $scope.showForSupplier(location) }));
            $scope.allSelected = true;
        } else {
            angular.forEach($scope.locations, (location) => {
                location.selected = false;
            });
            $scope.allSelected = false;
        }
    };

    $scope.selectLocation = function(location) {
        if (!location.selected) {
            $scope.allSelected = false;
        } else if (location.selected && !$scope.allSelected) {
            $scope.allSelected = $scope.isAllSelected();
        }
    };

    $scope.showForSupplier = function(location) {
        return(!(location.sharedWith && !$scope.supplyCoupon))
    };

    $scope.isAllSelected = function() {
        return $scope.locations.every(location => location.selected || !$scope.showForSupplier(location));
    };

    $scope.close = function() {
        // Go through locations and check what's selected, add to list to return
        const selectedLocations = [];

        angular.forEach($scope.locations, (location) => {
            if (location.selected) {
                selectedLocations.push({id: location.id});
            }
        });

        if (selectedLocations.length > 0) {
            $uibModalInstance.close(selectedLocations);
        } else if ($scope.deptBasedCoupon) {
                $scope.errorMessage = 'At least one department needs to be selected';
            } else {
                $scope.errorMessage = gettextCatalog.getString('At least one outlet needs to be selected');
            }
    };
});



// WEBPACK FOOTER //
// ./src/coupons/controllers/coupon.location.controller.js